var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.regions,"label":"AWS region","data-track":"region","rules":_vm.regionRules,"dense":"","clearable":"","outlined":"","required":""}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }